import styled from 'styled-components';

export const TemplateMessageModal = styled.div`
  padding: 1rem;

  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;
export const TemplateMessageModalHeader = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    font-weight: bold;

    margin-bottom: unset;
  }
`;

export const TemplateMessageModalBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: 1rem;
  max-height: 80vh;
  overflow: auto;
  padding-inline-end: 1rem;
`;

export const TemplateMessageModalFooter = styled.div`
  display: flex;
  justify-content: end;
`;

export const TemplateMessageSelectable = styled.div`
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #94a3b8;
  background-color: #f1f5f9;

  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;

  cursor: pointer;
  &:hover {
    background-color: #cbd5e1;
  }
`;

export const TemplateMessageSelectableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 1rem;

  span {
    font-weight: 600;
    text-wrap: balance;

    &:nth-of-type(2) {
      justify-self: end;
    }
  }
`;
export const TemplateMessageSelectableBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.5rem;

  &:not(:has(div + div)) > div {
    grid-column: span 2;
  }

  & > div {
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;

    /* A renderização do email/whatsapp precisa ter um limite de altura */
    & > div {
      max-height: 10em;
      overflow: auto;

      /* As mensagens que vêm como email podem ter imagens inclusas em si, por isso é necessário limitar a largura dessas imagens */
      img {
        max-width: 100%;
      }
    }
  }

  & > div > span {
    font-weight: 500;
    font-size: 0.9rem;
    word-break: break-all;
  }
`;
export const TemplateMessageSelectableFooter = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-column-gap: 0.5rem;

  &:not(:has(img)) {
    display: flex;
  }

  img {
    max-width: 100%;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }

  & > div > a {
    word-break: break-all;
  }
`;
